<template>
  <div
    class="calico-tier-indicator"
    :class="[colorClass]"
  >
    <div
      v-for="n in total"
      :key="n"
      class="segment"
    >
      <span
        v-if="n > 1"
        class="connector"
        :class="{ complete: n <= activeClamped }"
      />
      <span
        class="dot"
        :class="{ filled: n <= activeClamped }"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'CalicoTierIndicator',
  props: {
    total: { 
      type: Number, 
      default: 5 
    },
    active: { 
      type: Number, 
      default: 0 
    },
    colorClass: { 
      type: String, 
      default: '' 
    },
  },
  computed: {
    activeClamped() {
      if (this.active < 0) return 0
      if (this.active > this.total) return this.total
      return this.active
    }
  }
}
</script>

<style lang="scss" scoped>
.calico-tier-indicator {
  @include inline-space($space-none);
  align-items: center;

  .dot { 
    width: 12px; 
    height: 12px; 
    border-radius: $radius-round;
    background: $color-neutral-light;
  }
  .connector { 
    height: 1px; 
    width: $space-small;
    background: $color-neutral-light;
  }

  .segment {
    @include inline-space($space-none);
    align-items: center;
  }

  .dot.filled {
    background: currentColor;
  }

  &.tier--prime   { color: $color-green; }
  &.tier--growth  { color: $color-cyan; }
  &.tier--emerging{ color: $color-yellow; }
  &.tier--monitor { color: $color-orange; }
  &.tier--caution { color: $color-pink; }
}
</style>
